"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const E = require("fp-ts/lib/Either");
const _1 = require(".");
// https://emailregex.com
const reRfc5322ish = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
function isValidEmail(sEmail) {
    return reRfc5322ish.test(sEmail);
}
function emailV(path) {
    return x => isValidEmail(x)
        ? E.right(x)
        : E.left([
            new _1.ValidationError(path, `${x} is invalid email`, new InvalidEmailInfo()),
        ]);
}
exports.emailV = emailV;
class InvalidEmailInfo {
    constructor() {
        this.type = 'invalidEmail';
    }
}
